import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetAllPR_City = createAsyncThunk(
  "dropdowns/GetAllPR_City",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("/api/DropDowns/GetAllPR_City");

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const PR_CityDropDown = createSlice({
  name: "PR_CityDropDown",
  initialState: {
    PR_CityDropDown: [],
    loadingPR_CityDropDown: false,
    errorPR_CityDropDown: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllPR_City.pending, (state, action) => {
        state.loadingPR_CityDropDown = true;
        state.PR_CityDropDown = action.payload;
        state.errorPR_CityDropDown = null;
      })
      .addCase(GetAllPR_City.fulfilled, (state, action) => {
        state.loadingPR_CityDropDown = false;
        state.PR_CityDropDown = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllPR_City.rejected, (state, action) => {
        state.loadingPR_CityDropDown = false;
        state.errorPR_CityDropDown = action.payload;
      });
  },
});

export default PR_CityDropDown.reducer;
